import { useState, useRef, useEffect } from 'react';

import palette from '@lib/core/src/theme/palette';
import { IconButton } from '@mui/material';
import { RiArrowUpLine, RiSquareFill } from '@remixicon/react';

import {
  ButtonContainer,
  Container,
  InputWrapper
} from '@/components/AskMeAnything/components/ChatInputStyle';
import { TextInput } from '@/components/AskMeAnything/components/IndependentChatInput/IndependentChatInputStyles';
import { useStreamAbortController, useIsStreaming } from '@/store/chat/chatStore';
import { useIsSmallScreen } from '@/utils/mediaUtil';

interface ChatInputProps {
  onSubmit: (prompt: string) => void;
}

const ChatInput = ({ onSubmit }: ChatInputProps) => {
  const isStreamingChat = useIsStreaming();
  const streamAbortController = useStreamAbortController();
  const [prompt, setPrompt] = useState('');
  const isSmallScreen = useIsSmallScreen();
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = () => {
    onSubmit(prompt.trim());
    setPrompt('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (!isSmallScreen) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        handleSubmit();
      }
    }
  };

  return (
    <InputWrapper>
      <Container>
        <TextInput
          ref={inputRef}
          minRows={isSmallScreen ? 3 : 1}
          maxRows={5}
          sx={{ padding: '10px' }}
          placeholder="Ask me anything"
          value={prompt}
          onChange={e => setPrompt(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        {isStreamingChat ? (
          <IconButton onClick={() => streamAbortController?.abort()}>
            <ButtonContainer sx={{ backgroundColor: palette.black }}>
              <RiSquareFill color={palette.white} size={14} />
            </ButtonContainer>
          </IconButton>
        ) : (
          <IconButton onClick={handleSubmit} disabled={!prompt}>
            <ButtonContainer sx={{ backgroundColor: prompt ? palette.black : palette.grey[200] }}>
              <RiArrowUpLine color={palette.white} />
            </ButtonContainer>
          </IconButton>
        )}
      </Container>
    </InputWrapper>
  );
};

export default ChatInput;
